import React, {useEffect, useState} from "react";
import {fetchProducts} from "../util/Api";
import ClayLoadingIndicator from "@clayui/loading-indicator";
import ComparisonTable from "./ComparisonTable";
import {DAMAGE_REPORT_REFERENCE_NUMBER_PARAM_NAME, getParam, IDS_URL_PARAM_NAME} from "../util/ParamUtil";
import {CartsContext} from "../util/Context";

export default function Comparison() {
    const [productsLoading, setProductsLoading] = useState(false);
    const [productsResponse, setProductsResponse] = useState({
        products: [],
        additionalTranslations: {
            "an-unexpected-error-occurred": "Unexpected error"
        },
        cartId: null,
        carts: {
            currentCart: null,
            otherCarts: [],
            otherInsuranceCarts: []
        }
    });

    function reloadProducts() {
        const urlParamIds = getParam(IDS_URL_PARAM_NAME);
        const damageReportReferenceNumber = getParam(DAMAGE_REPORT_REFERENCE_NUMBER_PARAM_NAME);
        setProductsLoading(true);
        fetchProducts(urlParamIds, damageReportReferenceNumber, isSingleChoiceMode())
            .then(json => setProductsResponse(json))
            .catch(exception => alert(exception))
            .finally(() => setProductsLoading(false));
    }

    useEffect(() => {
        reloadProducts();
    }, []);

    const getConfigurationAttribute = (attributeName, defaultValue) => {
        const rootElement = document.querySelector("up2date-comparison-table");
        let attributeValue = defaultValue;
        if (rootElement?.hasAttribute(attributeName)) {
            attributeValue = rootElement.getAttribute(attributeName);
        }
        return attributeValue;
    }

    const getMyCartUrl = () => {
        return getConfigurationAttribute("cart-page", "/my-cart");
    }

    const redirectToCart = () => {
        return getConfigurationAttribute("redirect-to-cart", "true") === "true";
    }
    const isSingleChoiceMode = () => {
        return getConfigurationAttribute("single-choice-mode", "false") === "true";
    }

    const addToCart = (productId, cartId) => {
        const removeFromCart = isSingleChoiceMode() ? getParam(IDS_URL_PARAM_NAME) : null;
        const addToCartId = cartId || productsResponse?.carts?.currentCart?.commerceOrderId;
        const callbacks = isSingleChoiceMode() ? {
            success: () => reloadProducts()
        } : {};
        if(redirectToCart()) {
            window.addToCart(productId, addToCartId, getMyCartUrl(), removeFromCart, callbacks);
        } else {
            window.addToCart(productId, addToCartId, null, removeFromCart, callbacks);
        }
    }

    const removeFromCart = (productId, cartId) => {
        const removeFromCartId = cartId || productsResponse?.carts?.currentCart?.commerceOrderId;
        const callbacks = isSingleChoiceMode() ? {
            success: () => reloadProducts()
        } : {};
        window.removeFromCart(removeFromCartId, productId, callbacks);
    }

    const removeFromComparison = (productId) => {
        setProductsResponse(productsResponse => {
            let newProducts = productsResponse.products.filter(product => product.id !== productId);
            let url = new URL(window.location);
            if (newProducts.length === 0 && url.searchParams.has("redirect")) {
                window.location.href = url.searchParams.get("redirect");
            } else {
                url.searchParams.set(IDS_URL_PARAM_NAME, url.searchParams.get(IDS_URL_PARAM_NAME)
                    .split(",")
                    .filter(id => id !== productId)
                    .join(','));
                window.history.pushState(null, '', url.toString());
            }
            return {
                ...productsResponse,
                products: newProducts
            };
        });

    }

    if(productsLoading) {
        return <ClayLoadingIndicator size={"md"}/>;
    }
    if (!productsResponse?.products?.length) {
        return <div className={"no-products-message"}>{productsResponse.additionalTranslations["no-products-were-found"]}</div>;
    }
    return (
        <CartsContext.Provider value={productsResponse.carts}>
        <ComparisonTable products={productsResponse.products} addToCart={addToCart}
                         translations={productsResponse.additionalTranslations}
                         removeFromComparison={removeFromComparison} removeFromCart={removeFromCart}
                         isSingleChoiceMode={isSingleChoiceMode()}/>
        </CartsContext.Provider>
    )
}
